const maintenancePage = {
  header: 'We are adding new functionalities for you',
  description:
    'The website is currently undergoing scheduled maintenance. We should be back shortly',
  callToAction: 'Please try again later',
};

export default maintenancePage;
